var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoToTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 24,
    r: 23,
    fill: "#6C5CE7",
    fillOpacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7315_13135)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6751 25.8374C8.76675 24.3832 9.00078 20.1577 12.052 19.0336L29.703 12.5307C32.6747 11.4358 35.5646 14.3257 34.4697 17.2975L27.9667 34.9484C26.8426 37.9996 22.6171 38.2336 21.1629 35.3252L18.5538 30.1069C18.1945 29.3884 17.612 28.8059 16.8936 28.4467L11.6751 25.8374ZM12.4798 20.1948L30.1307 13.6918C32.1119 12.9619 34.0385 14.8885 33.3086 16.8697L26.8056 34.5206C26.0562 36.5547 23.2392 36.7107 22.2697 34.7718L19.6606 29.5535C19.5147 29.2617 19.3412 28.9868 19.1434 28.732L27.1878 20.6875C27.4295 20.4459 27.4295 20.0541 27.1878 19.8125C26.9462 19.5709 26.5545 19.5709 26.3128 19.8125L18.2684 27.857C18.0136 27.6592 17.7387 27.4857 17.447 27.3399L12.2285 24.7306C10.2896 23.7612 10.4456 20.9442 12.4798 20.1948Z",
    fill: "#2D3436"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7315_13135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(4 22) rotate(-45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoToTelegram);
export default __webpack_public_path__ + "static/media/go-to-telegram.72aaca8d7589b17f7bbfb6525575bc48.svg";
export { ForwardRef as ReactComponent };